import * as React from 'react';
import { Box } from '@leagueplatform/genesis-commons';
import {
  HighlightCard,
  CalloutBanner,
} from '@leagueplatform/web-common-components';
import { ParagraphText } from '@leagueplatform/genesis-core';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { useInvokeAction } from '@leagueplatform/masonry';

import type {
  MasonryDeeplinkAction,
  MasonryDriverAction,
} from '@leagueplatform/masonry-renderers';

type InsightHighlightCardProps = {
  heading: string;
  actionText: string;
  callout: {
    backgroundColor: string;
    body: string;
    image: string;
    imageAltText: string;
  };
  items: React.ReactElement[];
};

type MasonryLargeCardNodeActions = {
  onClick?: MasonryDriverAction;
};

type InsightHighlightCardNode = MasonryEngineNode<
  'insight_card',
  InsightHighlightCardProps,
  MasonryLargeCardNodeActions
>;

type InsightHighlightCardRendererProps =
  MasonryEngineNodeRendererProps<InsightHighlightCardNode>;

export const InsightHighlightCardNodeRenderer = ({
  heading,
  actionText,
  callout,
  onClick,
  items,
}: InsightHighlightCardRendererProps) => {
  const invokeAction = useInvokeAction();

  return (
    <HighlightCard
      title={heading}
      actionLink={(onClick as MasonryDeeplinkAction)?.payload?.url}
      onClick={(event: React.MouseEvent) => {
        if (onClick) {
          invokeAction({
            event,
            ...onClick,
          });
        }
      }}
      actionText={actionText}
    >
      <CalloutBanner icon={callout.image} label={callout.imageAltText}>
        <ParagraphText>{callout.body}</ParagraphText>
      </CalloutBanner>
      <Box mt="two">{items}</Box>
    </HighlightCard>
  );
};
